// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `button.button {
  outline: none;
  border: none;
  transition: 0.3s all ease-in-out;
  display: flex;
  align-items: center;
  text-align: center;
  box-shadow: 0px 10px 12px -6px #3d9877;
  cursor: pointer;
  font-family: "Roboto";
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 19px;
  border-radius: 20px;
  position: relative;
}
button.button a {
  color: white;
}
button.button svg,
button.button icon {
  margin-left: 18px;
  margin-right: 12px;
}
button.button.small {
  padding: 9px 0px;
  font-weight: 400;
  font-size: 14px;
  width: 74px;
  height: 34px;
}
button.button.middle {
  padding: 9px 0px;
  font-weight: 400;
  width: 105px;
  height: 37px;
}
button.button.large {
  padding: 11px 0px;
  width: 230px;
  height: 40px;
}
button.button.full {
  padding: 9px 0px;
  width: 100%;
}
button.button.default {
  background: #00955f;
  box-shadow: 0px 10px 15px -7px rgba(61, 152, 119, 0.75);
  color: white;
}
button.button.default:hover {
  background-color: #0ab475;
}
button.button.default:focus {
  background-color: #0ab475;
}
button.button.danger {
  background: #9c0e0e;
  color: #ffffff;
}
button.button.danger:hover {
  transition: 0.3s all ease-in-out;
  background: #ff0000;
}
button.button.ghost {
  color: #00955f;
  background: #ffffff;
  border: 1px solid #00955f;
  box-shadow: none;
}
button.button.ghost a {
  color: #00955f;
}
button.button.ghost:focus, button.button.ghost:active {
  background: #ffffff;
  color: #00955f;
  border: 1px solid #00955f;
  outline: none;
  box-shadow: none;
}
button.button.ghost:hover {
  transition: 0.3s all ease-in-out;
  background: #ebebeb;
  color: #00955f;
  border-color: #ebebeb;
}
button.button.primary {
  color: #ffffff;
  margin-bottom: 15px;
  background: #4285f4;
  box-shadow: 0px 10px 15px -7px rgba(80, 146, 255, 0.75);
}
button.button.primary:hover {
  transition: 0.3s all ease-in-out;
  background: #276ad9;
}
button.button.primary:focus {
  background: #276ad9;
}
button.button.link {
  transition: 0.3s all ease-in-out;
  padding: 0;
  box-shadow: none !important;
  background: none;
}
button.button.link a {
  transition: 0.3s all ease-in-out;
  padding: 0;
  border: 0;
  text-decoration: underline;
  color: #1890ff;
  box-shadow: none !important;
}
button.button.link:hover {
  background: none;
}
button.button.link:hover a {
  color: #055baa;
  text-decoration: underline;
}
button.button:disabled {
  border-color: #d9d9d9;
  opacity: 0.5;
  box-shadow: none;
  cursor: no-drop;
}
button.button:disabled:hover {
  border-color: #d9d9d9;
  opacity: 0.5;
}
button.button a {
  width: 100%;
  position: absolute;
  left: 0;
  top: 0;
  bottom: 0;
  right: 0;
  display: flex;
  align-items: center;
  justify-content: center;
}

.alert {
  padding: 9px 15px;
  box-shadow: 0px 5px 20px 0px rgba(0, 0, 0, 0.15);
  border-radius: 2px;
  margin-bottom: 10px;
  width: auto;
  max-width: -webkit-max-content;
  max-width: max-content;
}
.alert_message {
  font-family: "Roboto";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 16px;
  color: #000000;
  margin-bottom: 0;
}
.alert_description {
  font-family: "Roboto";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 19px;
  color: #000000;
  margin-bottom: 0;
  margin-top: 10px;
}
.alert.success {
  background: #a6ffaf;
}
.alert.warning {
  background: #ffe58f;
}
.alert.info {
  background: #bfebff;
}
.alert.error {
  background: #fff2f0;
  border: 1px solid #ffccc7;
  padding: 10px 15px;
}
.alert.ua {
  background: #ffe58f;
  border: 1px solid #ffe58f;
}

.preloader {
  width: 200px;
  height: 200px;
  position: absolute;
  left: calc(50% - 100px);
  top: calc(50% - 100px);
  z-index: 10;
}`, "",{"version":3,"sources":["webpack://./src/styles/platform-elements.scss","webpack://./src/styles/variables.scss"],"names":[],"mappings":"AAQA;ECyBI,aAAA;EACA,YAAA;EACA,gCAAA;EACA,aAAA;EACA,mBAAA;EACA,kBAAA;EACA,sCA/BS;EAgCT,eAAA;EACA,qBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,mBAAA;EACA,kBAAA;AD3BJ;AATE;EACE,YAAA;AAWJ;AARE;;EAEE,iBAAA;EACA,kBAAA;AAUJ;AAPE;EACE,gBAAA;EACA,gBAAA;EACA,eAAA;EACA,WAAA;EACA,YAAA;AASJ;AANE;EA1BA,gBAAA;EA4BE,gBAAA;EACA,YAAA;EACA,YAAA;AAQJ;AALE;EACE,iBAAA;EACA,YAAA;EACA,YAAA;AAOJ;AAJE;EAvCA,gBAAA;EAyCE,WAAA;AAMJ;AAHE;EACE,mBCvBU;EDwBV,uDAAA;EACA,YAAA;AAKJ;AAHI;EACE,yBC3Bc;ADgCpB;AAFI;EACE,yBC/Bc;ADmCpB;AAAE;EACE,mBCnCU;EDoCV,cAAA;AAEJ;AAAI;EACE,gCAAA;EACA,mBCvCa;ADyCnB;AAEE;EACE,cCpEQ;EDqER,mBAAA;EACA,yBAAA;EACA,gBAAA;AAAJ;AACI;EACE,cCzEM;AD0EZ;AAEI;EAEE,mBAAA;EACA,cC/EM;EDgFN,yBAAA;EACA,aAAA;EACA,gBAAA;AADN;AAII;EACE,gCAAA;EACA,mBAAA;EACA,cCxFM;EDyFN,qBAAA;AAFN;AAME;EACE,cAAA;EACA,mBAAA;EACA,mBCvEU;EDwEV,uDAAA;AAJJ;AAMI;EACE,gCAAA;EACA,mBC3Ec;ADuEpB;AAOI;EACE,mBC/Ec;AD0EpB;AASE;EACE,gCAAA;EACA,UAAA;EAEA,2BAAA;EACA,gBAAA;AARJ;AAUI;EACE,gCAAA;EACA,UAAA;EACA,SAAA;EACA,0BAAA;EACA,cAAA;EACA,2BAAA;AARN;AAWI;EACE,gBAAA;AATN;AAUM;EACE,cAAA;EACA,0BAAA;AARR;AAaE;EACE,qBAAA;EACA,YAAA;EACA,gBAAA;EACA,eAAA;AAXJ;AAaI;EACE,qBAAA;EACA,YAAA;AAXN;AAeE;EACE,WAAA;EACA,kBAAA;EACA,OAAA;EACA,MAAA;EACA,SAAA;EACA,QAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AAbJ;;AAqBA;EACE,iBAAA;EACA,gDAAA;EACA,kBAAA;EACA,mBAAA;EACA,WAAA;EACA,8BAAA;EAAA,sBAAA;AAlBF;AAoBE;EACE,qBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;EACA,gBAAA;AAlBJ;AAqBE;EACE,qBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;EACA,gBAAA;EACA,gBAAA;AAnBJ;AAsBE;EACE,mBAAA;AApBJ;AAuBE;EACE,mBAAA;AArBJ;AAwBE;EACE,mBAAA;AAtBJ;AAyBE;EACE,mBAAA;EACA,yBAAA;EACA,kBAAA;AAvBJ;AA0BE;EACE,mBAAA;EACA,yBAAA;AAxBJ;;AA6BA;EACE,YAAA;EACA,aAAA;EACA,kBAAA;EACA,uBAAA;EACA,sBAAA;EACA,WAAA;AA1BF","sourcesContent":["@import \"./variables.scss\";\n\n@mixin middle-padding {\n  padding: 9px 0px;\n}\n\n// -- BUTTON --\n\nbutton.button {\n  @include default-button;\n\n  a {\n    color: white;\n  }\n\n  svg,\n  icon {\n    margin-left: 18px;\n    margin-right: 12px;\n  }\n\n  &.small {\n    padding: 9px 0px;\n    font-weight: 400;\n    font-size: 14px;\n    width: 74px;\n    height: 34px;\n  }\n\n  &.middle {\n    @include middle-padding;\n    font-weight: 400;\n    width: 105px;\n    height: 37px;\n  }\n\n  &.large {\n    padding: 11px 0px;\n    width: 230px;\n    height: 40px;\n  }\n\n  &.full {\n    @include middle-padding;\n    width: 100%;\n  }\n\n  &.default {\n    background: $default-btn;\n    box-shadow: 0px 10px 15px -7px rgba(61, 152, 119, 0.75);\n    color: white;\n\n    &:hover {\n      background-color: $default-btn-hover;\n    }\n\n    &:focus {\n      background-color: $default-btn-hover;\n    }\n  }\n\n  &.danger {\n    background: $danger-btn;\n    color: #ffffff;\n\n    &:hover {\n      transition: 0.3s all ease-in-out;\n      background: $danger-btn-hover;\n    }\n  }\n\n  &.ghost {\n    color: $font-clor;\n    background: #ffffff;\n    border: 1px solid $font-clor;\n    box-shadow: none;\n    a {\n      color: $font-clor;\n    }\n\n    &:focus,\n    &:active {\n      background: #ffffff;\n      color: $font-clor;\n      border: 1px solid $font-clor;\n      outline: none;\n      box-shadow: none;\n    }\n\n    &:hover {\n      transition: 0.3s all ease-in-out;\n      background: #ebebeb;\n      color: $font-clor;\n      border-color: #ebebeb;\n    }\n  }\n\n  &.primary {\n    color: #ffffff;\n    margin-bottom: 15px;\n    background: $primary-btn;\n    box-shadow: 0px 10px 15px -7px rgba(80, 146, 255, 0.75);\n\n    &:hover {\n      transition: 0.3s all ease-in-out;\n      background: $primary-btn-hover;\n    }\n\n    &:focus {\n      background: $primary-btn-hover;\n    }\n  }\n\n  &.link {\n    transition: 0.3s all ease-in-out;\n    padding: 0;\n\n    box-shadow: none !important;\n    background: none;\n\n    a {\n      transition: 0.3s all ease-in-out;\n      padding: 0;\n      border: 0;\n      text-decoration: underline;\n      color: #1890ff;\n      box-shadow: none !important;\n    }\n\n    &:hover {\n      background: none;\n      a {\n        color: #055baa;\n        text-decoration: underline;\n      }\n    }\n  }\n\n  &:disabled {\n    border-color: #d9d9d9;\n    opacity: 0.5;\n    box-shadow: none;\n    cursor: no-drop;\n\n    &:hover {\n      border-color: #d9d9d9;\n      opacity: 0.5;\n    }\n  }\n\n  a {\n    width: 100%;\n    position: absolute;\n    left: 0;\n    top: 0;\n    bottom: 0;\n    right: 0;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n  }\n}\n\n// -- BUTTON --\n\n// -- ALERTS --\n\n.alert {\n  padding: 9px 15px;\n  box-shadow: 0px 5px 20px 0px rgba(0, 0, 0, 0.15);\n  border-radius: 2px;\n  margin-bottom: 10px;\n  width: auto;\n  max-width: max-content;\n\n  &_message {\n    font-family: \"Roboto\";\n    font-style: normal;\n    font-weight: 400;\n    font-size: 14px;\n    line-height: 16px;\n    color: #000000;\n    margin-bottom: 0;\n  }\n\n  &_description {\n    font-family: \"Roboto\";\n    font-style: normal;\n    font-weight: 400;\n    font-size: 14px;\n    line-height: 19px;\n    color: #000000;\n    margin-bottom: 0;\n    margin-top: 10px;\n  }\n\n  &.success {\n    background: #a6ffaf;\n  }\n\n  &.warning {\n    background: #ffe58f;\n  }\n\n  &.info {\n    background: #bfebff;\n  }\n\n  &.error {\n    background: #fff2f0;\n    border: 1px solid #ffccc7;\n    padding: 10px 15px;\n  }\n\n  &.ua {\n    background: #ffe58f;\n    border: 1px solid #ffe58f;\n  }\n}\n// -- ALERTS --\n\n.preloader {\n  width: 200px;\n  height: 200px;\n  position: absolute;\n  left: calc(50% - 100px);\n  top: calc(50% - 100px);\n  z-index: 10;\n}\n","$main: rgba(1, 83, 34, 0.7);\n$background: #fbfbfb;\n$white-color: #ffffff;\n$header-background: white;\n$font-clor: #00955f;\n$font-color-grey: #6b6b6b;\n$shadow: 0px 10px 50px -15px rgba(132, 132, 132, 0.3);\n$border-radius-btn: 20px;\n$shadow-btn: 0px 10px 12px -6px #3d9877;\n\n$grey-background: #f1f1f1;\n$grey-color: #757575;\n$blue-background: #46a6ff;\n\n:export {\n    color: $main;\n}\n\n$width_auth_description_block: 275px;\n// $retina: \"(-webkit-min-device-pixel-ratio: 2), (min-resolution: 192dpi)\";\n\n$mobile: 320px;\n$tablet: 768px;\n$desktop: 1000px;\n\n$default-btn: #00955f;\n$default-btn-hover: #0ab475;\n$danger-btn:  #9c0e0e;\n$danger-btn-hover: #ff0000;\n$primary-btn: #4285f4;\n$primary-btn-hover: #276ad9;\n\n@mixin default-button {\n    outline: none;\n    border: none;\n    transition: 0.3s all ease-in-out;\n    display: flex;\n    align-items: center;\n    text-align: center;\n    box-shadow: $shadow-btn;\n    cursor: pointer;\n    font-family: \"Roboto\";\n    font-style: normal;\n    font-weight: 400;\n    font-size: 16px;\n    line-height: 19px;\n    border-radius: 20px;\n    position: relative;\n}\n\n@mixin green-hover {\n    transition: 0.3s all ease-in-out;\n    background: $green-gradient-hover;\n    color: #ffffff;\n}\n\n@mixin green-focus {\n    @include green-hover;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"color": `rgba(1, 83, 34, 0.7)`
};
export default ___CSS_LOADER_EXPORT___;
